import fixture from './fixture';
import steps from './steps';

const FILE_NAME = 'embroidery_sample.png';

/**
 * Simple Flower — the introductory embroidery lesson.
 *
 * Bundles everything tied to this one piece of artwork: the card shown in the
 * picker, the pinned palette and stitch settings the editor should start from,
 * and the walkthrough itself.
 */
const flowerTutorial = {
  id: 'flower',
  design: {
    id: 'flower',
    name: 'Simple Flower',
    level: 'Beginner',
    // Roughly how long a first-timer takes: the lesson's own narration, plus a
    // beat per click it asks for and the waits while the app traces, generates
    // and exports. See `docs/tutorial-timing.md`.
    minutes: 7,
    blurb: 'Three flat colours and one bold outline — the outline is what you\'ll turn into satin stitch.',
    image: `/assets/${FILE_NAME}`,
    fileName: FILE_NAME,
    ready: true,
  },
  fixture,
  steps,
};

export default flowerTutorial;
